import React, { Ref, useImperativeHandle } from 'react'
import { StyleSheet } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'

import List, { Props as ListProps } from './list'

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
})

export interface Props extends ListProps {
  test_ref?: Ref<any>
}
const Safearealist = (props: Props) => {
  const { test_ref, getItemLayout, onRefresh, onEndReached, ...otherProps } = props

  useImperativeHandle(test_ref, () => ({
    getItemLayout: (data: any[], index: number) => {
      return getItemLayout?.(data, index)
    },
    onRefresh: () => onRefresh?.(),
    onEndReached: (info: { distanceFromEnd: number }) => onEndReached?.(info),
  }))

  return (
    <SafeAreaView style={styles.container} edges={['left', 'right', 'bottom']}>
      <List getItemLayout={getItemLayout} onRefresh={onRefresh} onEndReached={onEndReached} {...otherProps} />
    </SafeAreaView>
  )
}

export default Safearealist
